import React from 'react'
import { Modal } from '@zambezi/sdk/modal'

import style from './CancelFundsCheckModal.module.css'
import modalStyle from '@apiEnabler/ob-common/lib/view/modal.module.css'
import { getClientNameText } from '@apiEnabler/ob-common/lib/tpps'

export default function CancelFundsCheckModal({
  consent,
  open,
  onCancel,
  onConfirm,
}) {
  return (
    <Modal
      className={`${modalStyle.modal} js-modal`}
      title="Cancel funds check permission"
      withBackdrop
      withPadding
      open={open}
      onConfirm={onConfirm}
      onCancel={onCancel}
      renderFooter={(onConfirm, onCancel) => (
        <div className="zb-modal-card-foot-actions">
          <button
            className="js-confirm-action zb-button zb-button-primary zb-modal-action"
            onClick={onConfirm}
          >
            Cancel funds check permission
          </button>
          <button
            className="zb-button-link zb-modal-action js-cancel-action"
            onClick={onCancel}
          >
            Keep permission
          </button>
        </div>
      )}
    >
      <div className={style.content}>
        <p>
          <strong>
            {getClientNameText(
              consent.clientName,
              consent.agentName,
              consent.channelId
            )}
          </strong>{' '}
          won’t be able to check the availability of funds in your account,
          which may cause some transactions to be declined.
        </p>
        <p>
          If you want to grant access again, you’ll need to do it through the{' '}
          <b>service provider</b>.
        </p>
        <p>
          You should contact{' '}
          <strong>
            {getClientNameText(
              consent.clientName,
              consent.agentName,
              consent.channelId
            )}
          </strong>{' '}
          to inform them of the cancellation, and fully understand the potential
          implications of doing so.
        </p>
      </div>
    </Modal>
  )
}
